import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation('common');

  return (
    <section id="inicio" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Animated Background Image */}
      <div className="absolute inset-0">
        {/* Main animated background */}
        <div 
          className="absolute inset-0 bg-cover bg-center animate-ken-burns"
          style={{
            backgroundImage: `url('https://static.readdy.ai/image/44113e0bd02cf9d4b6e5b2a3bf2fb8ec/4865f70d56470b3b50dbc56018473f81.png')`
          }}
        ></div>
        
        {/* Animated overlay with gradient */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50 animate-pulse-slow"></div>
        
        {/* Floating particles effect */}
        <div className="absolute inset-0 opacity-30">
          {[...Array(15)].map((_, i) => (
            <div
              key={i}
              className="absolute w-2 h-2 bg-white rounded-full animate-float-particle"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 5}s`,
                animationDuration: `${8 + Math.random() * 4}s`,
              }}
            ></div>
          ))}
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center w-full py-32">
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
          {t('hero_title')}
        </h1>
        <p className="text-lg sm:text-xl lg:text-2xl text-white/95 mb-8 max-w-3xl mx-auto leading-relaxed">
          {t('hero_subtitle')}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://wa.me/13172790334"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-green-500 hover:bg-green-600 text-white px-8 py-4 rounded-full text-lg font-semibold transition-all shadow-2xl hover:shadow-green-500/50 hover:scale-105 flex items-center gap-3 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-2xl"></i>
            {t('hero_whatsapp')}
          </a>
          <button
            onClick={() => {
              const element = document.getElementById('contacto');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white border-2 border-white px-8 py-4 rounded-full text-lg font-semibold transition-all hover:scale-105 whitespace-nowrap"
          >
            {t('hero_location')}
          </button>
        </div>

        {/* Decorative Elements */}
        <div className="mt-16 grid grid-cols-2 sm:grid-cols-4 gap-8 text-white/90 max-w-4xl mx-auto">
          <div className="text-center">
            <div className="w-16 h-16 flex items-center justify-center mx-auto mb-3">
              <i className="ri-store-2-fill text-5xl"></i>
            </div>
            <p className="text-sm font-medium">{t('hero_authentic')}</p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 flex items-center justify-center mx-auto mb-3">
              <i className="ri-price-tag-3-fill text-5xl"></i>
            </div>
            <p className="text-sm font-medium">{t('hero_prices')}</p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 flex items-center justify-center mx-auto mb-3">
              <i className="ri-customer-service-2-fill text-5xl"></i>
            </div>
            <p className="text-sm font-medium">{t('hero_service')}</p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 flex items-center justify-center mx-auto mb-3">
              <i className="ri-box-3-fill text-5xl"></i>
            </div>
            <p className="text-sm font-medium">{t('hero_shipping')}</p>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>

      <style>{`
        @keyframes ken-burns {
          0% {
            transform: scale(1) translateX(0) translateY(0);
          }
          25% {
            transform: scale(1.1) translateX(-2%) translateY(-2%);
          }
          50% {
            transform: scale(1.15) translateX(2%) translateY(1%);
          }
          75% {
            transform: scale(1.1) translateX(-1%) translateY(2%);
          }
          100% {
            transform: scale(1) translateX(0) translateY(0);
          }
        }

        @keyframes float-particle {
          0%, 100% {
            transform: translateY(0) translateX(0);
            opacity: 0;
          }
          10% {
            opacity: 1;
          }
          90% {
            opacity: 1;
          }
          50% {
            transform: translateY(-100px) translateX(50px);
          }
        }

        @keyframes pulse-slow {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.8;
          }
        }

        .animate-ken-burns {
          animation: ken-burns 30s ease-in-out infinite;
        }

        .animate-float-particle {
          animation: float-particle 12s ease-in-out infinite;
        }

        .animate-pulse-slow {
          animation: pulse-slow 8s ease-in-out infinite;
        }
      `}</style>
    </section>
  );
}
